<template>
  <div class="page" @click.stop="hideShare">

    <!-- 搜索栏 -->
    <div class="search-bar">
      <searchbar @inputfinish="research" />
    </div>

    <div v-if="collData" class="body">

      <!-- 馆藏标题 -->
      <div class="body-title flex">
        <p class="font-size-30 font-bold">{{ collData.collName }}</p>
      </div>

      <!-- 展览资源展示区域 -->
      <div v-if="collData.resourcesVo.length" class="body-source flex radius-clip-5 position-relative" :class="isFull?'full-screen':''">
        <div class="body-source-wrap position-relative flex-1">
          <photo-preview v-if="currentSource.resourceType == 'image'" :is-full="isFull" :imgsrc="currentSource.resourceCloudUrl" @showmark="showSourceMark" @fullscreen="showFullScreen" />
          <div v-else-if="currentSource.resourceType == 'video'" class="position-relative mach-height mach-width">
            <div class="position-absolute body-source-wrap-video-info-btn cursor" @click.stop.stop="showSourceMark">
              <img src="../../../assets/icon-lib-source-mark.png" alt="">
            </div>
            <div id="body-source-wrap-video" class="video-normal" :class="isFull?'video-full-screen':''" />
          </div>
          <audio-preview v-else-if="currentSource.resourceType == 'audio'" :src="currentSource.resourceCloudUrl" @showmark="showSourceMark" @startPlay="audioStartPlay" />
          <pdf-preview v-else-if="currentSource.resourceType == 'pdf'" :src="currentSource.resourceCloudUrl" @showmark="showSourceMark" @fullscreen="showFullScreen" />
          <div v-else-if="currentSource.resourceType == 'zip'" class="body-source-wrap-zip" />
          <!-- 资源标注弹层 -->
          <div v-if="sourceMarkShowed" class="position-absolute body-source-mark">
            <div class="body-source-mark-item flex">
              <div class="body-source-mark-item-tit">
                <p class="font-size-12 font-color-white font-bold">标题</p>
              </div>
              <div class="body-source-mark-item-desc flex-1">
                <p class="font-size-12 font-color-white">{{ currentSource.resourceName }}</p>
              </div>
            </div>

            <div class="body-source-mark-item flex">
              <div class="body-source-mark-item-tit">
                <p class="font-size-12 font-color-white font-bold">资源描述</p>
              </div>
              <div class="body-source-mark-item-desc flex-1">
                <p class="font-size-12 font-color-white">{{ currentSource.description }}</p>
              </div>
            </div>

            <div v-if="currentSource.resourceType == 'image'" class="flex body-source-mark-list">
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.chronicleDate || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.genreName || '-' }}</p>
              </div>

              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">内容语种</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.langues == -1 ? '': currentSource.langues }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像尺寸</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.sizeOfThePicture || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像宽高比</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.widthHeight || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像位深度</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.pictureBitDepth || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">图像颜色模式</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.pictureColorMode || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.personAffected || '-' }}</p>
              </div>
            </div>
            <div v-else-if="currentSource.resourceType == 'video'" class="flex body-source-mark-list">
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.chronicleDate || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.genreName || '-' }}</p>
              </div>

              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">视频字幕语种</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.subtitleslangues }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">音频声道语种</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">时长</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ getDatePoor(currentSource.resourceTime) || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">画面宽高比</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.widthheight || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">编码格式</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据码率</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据帧率</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.personAffected || '-' }}</p>
              </div>
            </div>
            <div v-else-if="currentSource.resourceType == 'audio'" class="flex body-source-mark-list">
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.chronicleDate || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">资源体裁</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.genreName || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">声道语种</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">时长</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ getDatePoor(currentSource.resourceTime) || '-' }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">编码格式</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">数据码率</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">采样频率</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">音频位深度</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">声道数</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.resourceTime || '-' }}</p>
              </div>
            </div>
            <div v-else class="flex body-source-mark-list">
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">创作时间</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.chronicleDate }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">内容语种</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">{{ currentSource.langues == -1 ? '': currentSource.langues }}</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">文件格式</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">文件大小</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
              <div class="body-source-mark-list-item flex">
                <p class="body-source-mark-list-item-tit font-size-12 font-color-white font-bold">纪事人物</p>
                <p class="body-source-mark-list-item-desc font-size-12 font-color-white">-</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧资源列表 -->
        <div class="body-source-list">

          <div v-for="(item,index) in collData.resourcesVo" :key="index" class="body-source-list-item flex-row-align-center cursor" :class="currentIndex==index?'bg-262626':''" @click.stop="sourceSelect(index)">
            <div class="body-source-list-item-icon bg-444">
              <img v-if="item.resourceType == 'audio'" src="../../../assets/icon-lib-detail-audio.png" alt="">
              <img v-else-if="item.resourceType == 'pdf'" src="../../../assets/icon-lib-detail-pdf.png" alt="">
              <img v-else-if="item.resourceType == 'zip'" src="../../../assets/icon-lib-detail-zip.png" alt="">
              <el-image v-else-if="item.resourceType == 'image'" class="mach-width mach-height" :src="item.resourceCloudUrl" fit="cover" :lazy="true" />
              <el-image v-else-if="item.resourceType == 'video'" class="mach-height mach-width" :src="item.previewUrl" fit="cover" :lazy="true" />
            </div>
            <div class="body-source-list-item-info flex-1">
              <p class="font-size-14 font-color-ccc text-line-1">{{ item.resourceName }}</p>
              <p v-if="item.resourceType=='image'" class="font-size-12 font-color-666 body-source-list-type">图片</p>
              <p v-else-if="item.resourceType == 'audio'" class="font-size-12 font-color-666 body-source-list-type">音频</p>
              <p v-else-if="item.resourceType == 'video'" class="font-size-12 font-color-666 body-source-list-type">视频</p>
              <p v-else-if="item.resourceType == 'pdf'" class="font-size-12 font-color-666 body-source-list-type">PDF</p>
              <p v-else-if="item.resourceType == 'zip'" class="font-size-12 font-color-666 body-source-list-type">文件</p>
            </div>
          </div>

        </div>
      </div>

      <!-- 著录字段 -->
      <div class="body-mark flex">
        <div class="body-mark-left flex-1">

          <div v-if="collData.collectionName" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">标题</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.collectionName || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.subtitle" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">副标题</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.subtitle || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.chapter || collData.chapterOrder" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">目次/序列</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.chapter || '-' }}，{{ collData.chapterOrder || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.description" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">馆藏描述</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14" style="white-space: pre-wrap;">{{ collData.description || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.responsibleOfficer && collData.responsibleMethod" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">馆藏责任者/责任方式</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.responsibleOfficer || '-' }} / {{ collData.responsibleMethod || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.otherResponsibleOfficer && collData.otherResponsibleMethod" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">其它责任者/责任方式</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.otherResponsibleOfficer || '-' }} / {{ collData.otherResponsibleMethod || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.keyword" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">关键词</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.keyword || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.getCategory && collData.getCategory.length" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">馆藏分类</p>
            <div v-for="(cate,index) in collData.getCategory" :key="index" class="body-mark-left-item-value-wrap  flex category cursor" @click.stop="cateToSearch">
              <p class="font-size-14 font-color-264480 font-underline">{{ cate.cateName || '-' }} </p>
              <p class="font-size-14 font-color-666 line">/</p>
            </div>
          </div>

          <div v-if="collData.subjectName" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">学科</p>
            <div class="body-mark-left-item-value-wrap flex-1 flex">
              <p class="font-size-14 font-color-264480 font-underline cursor" @click.stop="subjectToSearch">{{ collData.subjectName || '-' }} </p>
            </div>
          </div>

          <div v-if="collData.areaListName && collData.areaListName.length" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">纪事地点</p>
            <div class=" flex-row-align-center mach-height mach-width flex-wrap flex-1">
              <div v-for="(item,index) in collData.areaListName" :key="index" class="flex date">
                <p class="font-size-14 font-color-264480 font-underline cursor" @click.stop="regionToSearch(item)">{{ item.areaName || '-' }} </p>
                <p class="font-size-14 font-color-666">,</p>
              </div>
            </div>
          </div>

          <div v-if="collData.personAffecteds" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">纪事人物</p>
            <div class="flex-row-align-center mach-height mach-width flex-wrap flex-1">
              <div v-for="s in collData.personAffecteds" :key="s" class="flex personaffecteds">
                <p class="font-size-14 font-color-264480 font-underline cursor" @click.stop="personToSearch(s)">{{ s }}</p>
                <p class="font-size-14 font-color-666">,</p>
              </div>
            </div>
          </div>

          <div v-if="collData.chronicleDate" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">纪事年份</p>
            <div class="body-mark-left-item-value-wrap flex-1 flex">
              <p class="font-size-14 font-color-264480 cursor" :class="collData.chronicleDate?'font-underline':''" @click.stop="dateToSearch">{{ collData.chronicleDate || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.collectionLevel" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">馆藏级别</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.collectionLevelName || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.ageRange" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">典型年龄范围</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.ageRangeName || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.collectionInfo" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">馆藏信息</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.collectionInfo || '-' }}</p>
            </div>
          </div>

          <div v-if="collData.copyrightOwner" class="body-mark-left-item flex">
            <p class="body-mark-left-item-key font-size-14 font-bold">版权拥有者</p>
            <div class="body-mark-left-item-value-wrap flex-1">
              <p class="body-mark-left-item-value font-size-14">{{ collData.copyrightOwner || '-' }}</p>
            </div>
          </div>

        </div>

        <div class="body-mark-right">

          <div class="body-mark-right-tool">
            <div class="body-mark-right-tool-item flex-row-align-center cursor" @click.stop="addCollect">
              <img v-if="collData.islikeCollection==1" src="../../../assets/icon-lib-source-colled.png" alt="">
              <img v-else-if="collData.islikeCollection==2" src="../../../assets/icon-lib-source-uncoll.png" alt="">
              <p v-if="collData.islikeCollection==1" class="font-size-14 font-color-264480 font-bold">已收藏</p>
              <p v-else-if="collData.islikeCollection==2" class="font-size-14 font-color-264480 font-bold">收藏</p>
            </div>
            <div class="body-mark-right-tool-item flex-row-align-center cursor position-relative" @click.stop.stop="showShare = true">
              <img src="../../../assets/icon-lib-source-share.png" alt="">
              <p class="font-size-14 font-color-264480 font-bold">分享</p>

              <div v-if="showShare" class="share-tip flex-row-align-center position-absolute bg-white">
                <div class="share-code flex-column-align-center">
                  <p class="font-size-14">微信扫一扫分享</p>
                  <div class="share-code-img">
                    <vueQr :text="shareUrl" :margin="0" :size="100" />
                  </div>
                </div>
                <div class="flex-1 share-plantform flex-center cursor">
                  <div class="flex-column-align-center" @click.stop="shareToQQ">
                    <img src="../../../assets/icon-lib-share-qq.png" style="padding: 0; margin: 0;" alt="">
                    <p class="font-size-14" style="margin-top: 8px">QQ</p>
                  </div>
                  <div class="flex-column-align-center cursor" style="margin-left: 30px;" @click.stop="sinaWeiBo">
                    <img src="../../../assets/icon-lib-share-weibo.png" style="padding: 0; margin: 0;" alt="">
                    <p class="font-size-14" style="margin-top: 8px">微博</p>
                  </div>
                </div>
              </div>

            </div>
            <div class="body-mark-right-tool-item flex-row-align-center cursor" @click.stop="reportColl">
              <img src="../../../assets/icon-lib-source-report.png" alt="">
              <p class="font-size-14 font-color-264480 font-bold">举报</p>
            </div>
          </div>

          <div class="body-mark-right-related">

            <div v-if="relatedTopic" class="body-mark-right-related-topic">
              <p class="font-bold font-size-14 body-mark-right-related-title">关联专题</p>
              <div class="flex" @click.stop="topicToSearch">
                <p class="font-size-14 font-color-264480 font-underline cursor line-height-space">#{{ relatedTopic.topicName }}</p>
              </div>
            </div>

            <!-- <div class="body-mark-right-related-show">
              <p class="font-bold font-size-14 body-mark-right-related-title">关联展览</p>
              <div class="flex">
                <p class="font-size-14 font-color-264480 font-underline cursor">“抗疫情话担当”特藏展览</p>
              </div>
            </div> -->

            <div v-if="collData.collectionsChapter.length" class="body-mark-right-related-series">
              <p class="font-bold font-size-14 body-mark-right-related-title">系列馆藏</p>
              <div>
                <p v-for="(item,index) in collData.collectionsChapter" :key="index" class="font-size-14 font-color-264480 font-underline text-line-1 cursor line-height-space" @click.stop="relatedResource(item)">{{ item.chapter?item.chapter + ',': '' }}{{ item.collectionName }}{{ item.subtitle?"-"+item.subtitle:'' }}</p>
              </div>
            </div>

            <div v-if="collData.commitByType == 1 && collData.user && collData.user.name" class="body-mark-right-related-publisher" @click="pubmanToSearch">
              <p class="font-bold font-size-14 body-mark-right-related-title">发布人</p>
              <div class="">
                <p class="font-size-14 font-color-264480 font-underline text-line-1 cursor">{{ collData.user.name }}</p>
              </div>
            </div>

            <div v-if="collData.commitByType == 2 && collData.team && collData.user.name" class="body-mark-right-related-publisher" @click="pubmanToSearch">
              <p class="font-bold font-size-14 body-mark-right-related-title">发布人</p>
              <div class="">
                <p class="font-size-14 font-color-264480 font-underline text-line-1 cursor">{{ collData.user.name }}</p>
              </div>
            </div>

            <div v-if="collData.publisherTime" class="body-mark-right-related-publisher">
              <p class="font-bold font-size-14 body-mark-right-related-title">发布日期</p>
              <div class="">
                <p class="font-size-14 text-line-1">{{ collData.publisherTime }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="requestError" class="flex-center mach-height mach-width font-size-16 error-view">
      馆藏不可见或已下架
    </div>
    <!-- 全屏播放 -->
    <fullscreensource v-if="collData" ref="fullscreen" :previe-index="currentIndex" />
    <apply-remove ref="delapply" :datas="reportList" @apply="requestReport" />

    <remote-js src="https://unpkg.com/navigator.sendbeacon" />
  </div>
</template>
<script>
  iFrame = document.getElementById('license_iframe')
  console.log('iFrame333333333',iFrame);
  iFrame.onload = function(){
//iframe加载完立即发送一条消息
  iFrame.contentWindow.postMessage({msg: 'MessageFromIndexPage'},'\*');
}
</script>
<script>
import navg from '../../../models/navigations.js'
import search from '../../../models/search.js'

import api from '../../../api/collections.js'
import collectApi from '../../../api/userpage.js'
import reportapi from '../../../api/common.js'
import user from '../../../models/user.js'
import auth from '../../../models/auth.js'
import searchModel from '../../../models/search.js'
import { replaceUrl } from '../../../utils/utils.js'
import config from '../../../utils/config.js'
import vueQr from 'vue-qr'
import searchbar from '@/components/Searchbar.vue'
import applyRemove from '@/components/applyremove/index.vue'
import photoPreview from '@/components/photoPreview/index.vue'
import audioPreview from '@/components/audioPreview/index.vue'
import pdfPreview from '@/components/pdfPreview/index.vue'
import fullscreensource from '@/components/fullscreensources/index.vue'
import flvjs from 'flv.js/dist/flv.min.js'

import DPlayer from 'dplayer'
window.flvjs = flvjs

export default {
  name: 'Resource',
  components: {
    searchbar,
    audioPreview,
    photoPreview,
    fullscreensource,
    pdfPreview,
    vueQr,
    applyRemove
  },
  data() {
    return {
      dplayer: null,
      sourceMarkShowed: false,
      showShare: false,
      shareUrl: '',
      currentSource: null,
      currentIndex: 0,
      rsId: 0,
      fId: 0,
      collData: null,
      reportList: null,
      statisticsData: {
        resourceId: 0,
        resourceTime: 0
      },
      timerCounter: null,
      requestError: false,

      relatedTopic: null,

      fromShare: 0,

      isFull: false,
      iprange: false,
      permissions: null
    }
  },
  mounted(){
    // const player = document.getElementById('body-source-wrap-video')
    // console.log('player',player);
    // document.getElementById('body-source-wrap-video').oncontextmenu=new Function("event.returnValue=false;");
    // document.getElementById('body-source-wrap-video').onselectstart=new Function("event.returnValue=false;");
  },
  created() {
    let hostname = "https://"+window.location.hostname
    this.rsId = this.$route.query.rsId
    this.fId = this.$route.query.fId || 0
    this.fromShare = this.$route.query.share || 0
    this.permissions = parseInt(this.$route.query.permission)
    if (this.$route.query.me && this.$route.query.me === '1') {
      this.permissions = 1
    }
    this.shareUrl = hostname + '/#/wap/detail?rsId=' + this.rsId//config.profile.pcHost + '/#/wap/detail?rsId=' + this.rsId
    this.checkIP()
    navg.navigatorIndex = 3
    replaceUrl()
    window.addEventListener('unload', this.requestStatistics)
  },
  destroyed() {
    window.removeEventListener('unload', this.requestStatistics)
    this.destroyCounter()
    this.requestStatistics()
    document.title = '数字特藏平台'
  },
  activated() {
     // 禁止右键下载视频
    //  document.oncontextmenu=new Function("event.returnValue=false;");
    //   document.onselectstart=new Function("event.returnValue=false;");
    const titleAry = []
    if (this.collData) {
      if (this.collData.collectionName) {
        titleAry.push(this.collData.collectionName)
      }
      if (this.collData.subtitle && this.collData.subtitle !== '') {
        titleAry.push(this.collData.subtitle)
      }

      if (this.collData.chapter && this.collData.chapter !== '') {
        titleAry.push(this.collData.chapter)
      }

      document.title = titleAry.join('-')
    }
  },
  methods: {
    hideShare() {
      this.showShare = false
    },
    checkIP() {
      const that = this
      api.ip({ tenantId: this.$store.getters.tenantId }).then(() => {
        that.iprange = true
        that.request()
      }).catch(() => {
        that.iprange = false
        that.request()
      })
    },
    request() {
      const that = this
      const userdata = user.getUserData()
      if (that.permissions === 2 && that.iprange === false) {
        if (!userdata) {
          that.$router.push({
            name: 'Login',
            query: {
              r: '/resource?rsId=' + that.rsId + '&permission=' + that.permissions
            }
          })
          return
        } else if (!userdata.typeCode === 'P0') {
          that.$router.push({
            name: 'Auth',
            query: {
              r: '/resource?rsId=' + that.rsId + '&permission=' + that.permissions,
              skip: 'n'
            }
          })
          return
        }
      }

      api.detail({ collectionId: this.rsId }).then(r => {
        if (!that.iprange) {
          const userdata = user.getUserData()
          // if (r.data.permissionRange === 2) {
          //   if (!userdata) {
          //     that.$router.push({
          //       name: 'Login',
          //       query: {
          //         r: '/resource?rsId=' + that.rsId
          //       }
          //     })
          //     return
          //   } else if (!userdata.typeCode === 'P0') {
          //     that.$router.push({
          //       name: 'Auth',
          //       query: {
          //         r: '/resource?rsId=' + that.rsId,
          //         skip: 'n'
          //       }
          //     })
          //     return
          //   }
          // }
          if (r.data.permissionRange === 4) {
            if (!userdata) {
              that.$router.push({
                name: 'Login',
                query: {
                  r: '/resource?rsId=' + that.rsId
                }
              })
              return
            } else if (userdata.id !== r.data.createUser) {
              that.requestError = true
              return
            }
          }

          if (that.permissions === 3) {
            that.requestError = true
            return
          }
        }

        const titleAry = []
        that.collData = that.prepareData(r.data)
        if (that.collData.collectionName) {
          titleAry.push(that.collData.collectionName)
        }
        if (that.collData.subtitle && that.collData.subtitle !== '') {
          titleAry.push(that.collData.subtitle)
        }

        if (that.collData.chapter && that.collData.chapter !== '') {
          titleAry.push(that.collData.chapter)
        }
        that.collData.collName = titleAry.join('-')
        document.title = that.collData.collectionName
        if (r.data.resourcesVo && r.data.resourcesVo.length) {
          if (that.fId !== 0) {
            r.data.resourcesVo.forEach((e, inx) => {
              if (parseInt(e.id) === parseInt(that.fId)) {
                that.currentSource = e
                that.currentIndex = inx
              }
            })
          } else {
            that.currentSource = r.data.resourcesVo[0]
          }
          if (!that.currentSource) {
            that.currentSource = r.data.resourcesVo[0]
          }

          that.statisticsData.resourceId = that.currentSource.resourceId
          if (that.currentSource.resourceType === 'video') {
            setTimeout(() => {
              that.play()
              document.getElementById('body-source-wrap-video').oncontextmenu=new Function("event.returnValue=false;");
              that.startCounter()
            }, 300)
          } else if (that.currentSource.resourceType === 'image' || that.currentSource.resourceType === 'pdf' || that.currentSource.resourceType === 'zip') {
            that.statisticsData.resourceTime = 1
          }
        }
      }).catch(error => {
        // 请求馆藏失败 给与提示
        that.requestError = true
        console.error(error)
      })

      reportapi.reportReason({ code: 'delete_type' }).then(r => {
        that.reportList = r.data
      }).catch(error => {
        console.error(error)
      })
    },
    startCounter() {
      if (this.timerCounter) {
        clearInterval(this.timerCounter)
        this.timerCounter = null
      }
      const that = this
      this.timerCounter = setInterval(() => {
        that.statisticsData.resourceTime += 1
      }, 1000)
    },
    destroyCounter() {
      if (this.timerCounter) {
        clearInterval(this.timerCounter)
        this.timerCounter = null
      }
    },
    audioStartPlay() {
      this.startCounter()
    },
    prepareData(v) {
      if (v.topicIdList.length) {
        console.log(v.topicIdList)
        const t = v.topicIdList[0]
        if (t.topicName && t.topicName !== '') {
          this.relatedTopic = t
        }
      }
      if (v.personAffected) {
        const ary = v.personAffected.split(',')
        v.personAffecteds = ary
      }
      return v
    },
    play() {
      this.dplayer = new DPlayer({
        container: document.getElementById('body-source-wrap-video'),
        autoplay: true,
        theme: '#23CEBC',
        loop: true,
        lang: 'zh-cn',
        screenshot: true,
        hotkey: true,
        preload: 'auto',
        mutex: true,
        video: {
          url: this.currentSource.resourceCloudUrl,
          type: 'mp4',
          pic: ''
        }
      })
    },
    showSourceMark() {
      this.sourceMarkShowed = !this.sourceMarkShowed
    },
    showFullScreen() {
      // this.$refs.fullscreen.showfull(this.collData.resourcesVo, this.currentIndex)
      this.isFull = !this.isFull
      document.body.style.overflow = this.isFull ? 'hidden' : 'auto'
    },
    pdferror(e) {
      console.log(e)
    },

    shareToQQ() {
      this.showShare = false
      var title = this.collData.title
      if (this.collData.subTitle) {
        title = title + this.collData.subTitle
      }
      if (this.collData.chapter) {
        title = title + this.collData.chapter
      }
      var p = {
        url: config.profile.pcHost + '/#/wap/detail?rsId=' + this.collData.id, /* 获取URL，可加上来自分享到QQ标识，方便统计*/
        desc: '来自数字特藏服务平台的分享', /* 分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/
        title: title, /* 分享标题(可选)*/
        summary: this.collData.description, /* 分享描述(可选)*/
        pics: this.collData.preview, /* 分享图片(可选)*/
        flash: '', /* 视频地址(可选)*/
        // commonClient : true, /*客户端嵌入标志*/
        site: '数字特藏服务平台'/* 分享来源 (可选) ，如：QQ分享*/
      }

      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var target_url = 'http://connect.qq.com/widget/shareqq/iframe_index.html?' + s.join('&')
      window.open(target_url, 'qq',
        'height=520, width=720')
    },
    sinaWeiBo() {
      this.showShare = false
      var title = this.collData.title
      if (this.collData.subTitle) {
        title = title + this.collData.subTitle
      }
      if (this.collData.chapter) {
        title = title + this.collData.chapter
      }
      var param = {
        url: config.profile.pcHost + '/#/resource?rsId=' + this.collData.id,
        type: '3',
        count: '1', /** 是否显示分享数，1显示(可选)*/
        appkey: '386438216', /** 您申请的应用appkey,显示分享来源(可选)*/
        title: title, /** 分享的文字内容(可选，默认为所在页面的title)*/
        pic: this.collData.preview,
        ralateUid: '',
        rnd: new Date().valueOf()
      }
      var temp = []
      for (var p in param) {
        temp.push(p + '=' + encodeURIComponent(param[p ] || ''))
      }
      var target_url = 'http://service.weibo.com/share/share.php?' + temp.join('&')
      window.open(target_url, 'sinaweibo',
        'height=520, width=720')
    },
    sourceSelect(index) {
      if (index === this.currentIndex) {
        return
      }
      this.currentIndex = index
      this.requestStatistics()
      this.currentSource = this.collData.resourcesVo[index]
      console.log('this.currentSource',this.currentSource);
      this.destroyCounter()
      this.statisticsData.resourceId = this.currentSource.resourceId
      this.statisticsData.resourceTime = 0
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      if (this.currentSource.resourceType === 'video') {
        const that = this
        setTimeout(() => {
          that.play()
          document.getElementById('body-source-wrap-video').oncontextmenu=new Function("event.returnValue=false;");
          that.startCounter()
        }, 1000)
      } else if (this.currentSource.resourceType === 'image' || this.currentSource.resourceType === 'pdf' || this.currentSource.resourceType === 'zip') {
        this.statisticsData.resourceTime = 1
      }
    },
    requestStatistics() {
      const formatData = new FormData()
      formatData.append('resourceId', this.statisticsData.resourceId)
      formatData.append('resourceTime', this.statisticsData.resourceTime)
      navigator.sendBeacon(`${config.profile.host}/adks-app/pc/apiv1/collection/addSave1`, formatData)
    },
    requestReport(v) {
      const params = {
        collectionId: this.rsId,
        complaintTypeCode: v.id,
        complaintContent: v.id === 8 ? v.desc : null
      }
      const that = this
      api.report(params).then(() => {
        that.$message({
          showClose: false,
          message: '举报成功',
          type: 'success'
        })
      }).catch(() => {
        that.$message({
          showClose: false,
          message: '举报失败',
          type: 'error'
        })
      })
    },
    reportColl() {
      if (auth.gettoken()) {
        this.$refs.delapply.show(1)
      } else {
        const that = this
        this.$router.push({
          path: '/login',
          query: {
            r: decodeURIComponent(that.$router.history.current.fullPath)
          }
        })
      }
    },
    addCollect() {
      if (!auth.gettoken()) {
        const that = this
        this.$router.push({
          path: '/login',
          query: {
            r: decodeURIComponent(that.$router.history.current.fullPath)
          }
        })
        return
      }
      if (this.collData.islikeCollection === 2) {
        const that = this
        collectApi.addColleciton({ collectionCode: this.collData.collectionId }).then(() => {
          that.collData.islikeCollection = 1
        }).catch(error => {
          console.error(error)
        })
      }
      if (this.collData.islikeCollection === 1) {
        const params = {
          collectionId: this.collData.collectionId,
          userId: user.getUserData().id
        }
        const that = this
        collectApi.removecollection(params).then(() => {
          that.collData.islikeCollection = 2
        }).catch(error => {
          console.error(error)
        })
      }
    },
    relatedResource(v) {
      const routeData = this.$router.resolve({
        name: 'Resource',
        query: {
          rsId: v.id,
          permission: v.permissionRange
        }
      })
      window.open(routeData.href, '_blank')
    },
    subjectToSearch() {
      search.viewData = { params: { subjects: this.collData.subjectId }, display: this.collData.subjectName, type: 'subjects' }
      this.$router.push({
        name: 'Collection'
      })
    },
    cateToSearch() {
      const v = this.collData.getCategory.pop()
      search.viewData = { params: { categoryId: v.id }, display: v.cateName, type: 'categoryId' }
      this.$router.push({
        name: 'Collection'
      })
    },
    personToSearch(v) {
      search.viewData = { params: { personAffected: v }, display: v, type: 'personAffected' }
      this.$router.push({
        name: 'Collection'
      })
    },
    dateToSearch() {
      search.viewData = { params: { chronicleDates: this.collData.chronicleDate }, display: this.collData.chronicleDate, type: 'chronicleDates' }
      this.$router.push({
        name: 'Collection'
      })
    },
    topicToSearch() {
      search.viewData = { params: { specialSubject: this.relatedTopic.id }, display: this.relatedTopic.topicName, type: 'specialSubject' }
      this.$router.push({
        name: 'Collection'
      })
    },
    regionToSearch(v) {
      search.viewData = { params: { areaAffected: v.areaCode }, display: v.areaName, type: 'areaAffected' }
      this.$router.push({
        name: 'Collection'
      })
    },
    pubmanToSearch() {
      if (this.collData.commitByType === 1) {
        search.viewData = { params: { commitBy: this.collData.createUser }, display: this.collData.user.name, type: 'commitBy' }
      } else {
        search.viewData = { params: { commitBy: this.collData.createUser }, display: this.collData.user.name, type: 'commitBy' }
      }

      this.$router.push({
        name: 'Collection'
      })
    },
    getDatePoor(v) {
      const nd = 24 * 60 * 60
      const nh = 60 * 60
      const nm = 60
      const hour = Math.floor(v / nh)
      const min = Math.floor(v % nd % nh / nm)
      const sec = Math.floor(v % 60)
      if (hour > 0) {
        return hour + '小时' + min + '分' + sec + '秒'
      } else {
        return min + '分' + sec + '秒'
      }
    },
    research() {
      searchModel.viewData = { params: null, display: null, type: '' }
      this.$router.push({ name: 'Collection' })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>

<style lang="scss" scoped>
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #264480;
  background: #264480;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color:  #264480;
}

.date {
  ::v-deep .el-input__inner {
     padding-left: 24px !important;
  }

  ::v-deep .dplayer-notice {
    display: none;
  }

  margin-bottom: 4px;
}

</style>

<style scoped>

.dplayer-notice {
    display: none!important;
  }
  .page {
    background-color: #fff;
    min-height: 746px;
  }

  .page .body {
    width: 1240px;
    padding-top: 120px;
    margin: 0 auto;
  }

  .body-title {
    margin-top: 60px;
  }

  .body-source {
    width: 1240px;
    height: 600px;
    margin-top: 25px;
    background-color: #000;
  }

  .body-mark {
    margin: 50px auto 0;
    width: 1240px;
  }

  .body-mark-right {
    width: 280px;
    margin-left: 40px;
    margin-bottom: 40px;
  }

  .body-mark-right-tool-item {
    height: 50px;
    background: #F3F4F9;
    padding: 0 25px;
    border-top: 1px solid #fff;
  }

  .body-mark-right-tool-item:first-child {
    border: none;
  }

  .body-mark-right-tool-item img {
    margin-right: 12px;
  }

  .body-mark-right-related {
    margin-top: 40px;
    width: 100%;
    border: 1px solid #EEEEEE;
    padding: 25px;
  }

  .body-mark-right-related>div{
    margin-bottom: 24px;
  }

  .body-mark-right-related>div:last-child {
    margin: 0;
  }

  .body-mark-right-related-title {
    height: 24px;
  }

  .line-height-space {
    line-height: 36px;
  }

  .body-mark-left-item {
    min-height: 64px;
    border-bottom: 1px solid #eee;
  }

  .body-mark-left-item-value {
    line-height: 24px;
    word-break: break-all;
  }

  .body-mark-left-item-value-wrap {
    padding: 20px 0;
  }

  .body-mark-left-item-key {
    width: 150px;
    margin-right: 60px;
    line-height: 64px;
  }

  .body-source-list {
    width: 280px;
    height: 100%;
    background-color: #333;
    overflow-y: scroll;
    flex-shrink: 0;
  }
  .body-source-list::-webkit-scrollbar {  /*滚动条整体样式*/
  width : 3px;
  height: 1px;
  }
  .body-source-list::-webkit-scrollbar-thumb {  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #535353;
  }
  .body-source-list::-webkit-scrollbar-track { /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background   : #999;
  }

  .body-source-list-item {
    height: 70px;
    margin-top: 10px;
    padding: 0 12px;
  }

  .body-source-list-item-sel {
    background-color: #262626;;
  }

  .body-source-list-item:first-child {
    margin: 0;
  }

  .body-source-list-item-info {
    margin-left: 8px;
    height: 50px;
  }

  .body-source-list-item-icon {
    width: 50px;
    height: 50px;
    overflow: hidden;
  }
  .body-source-mark {
    left: 0;
    right: 0;
    bottom: 0;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 998;
    padding: 12px 19px;
    z-index: 99;
    overflow: scroll;
  }

  .body-source-mark-item {
    min-height: 28px;
  }

  .body-source-mark-item-tit {
    width: 60px;
  }

  .body-source-mark-item-tit p {
    line-height: 28px;
  }

  .body-source-mark-item-desc {
    padding: 4px 0;
    margin-left: 50px;
  }

  .body-source-mark-item-desc p {
    line-height: 18px;
  }

  .body-source-mark-list {
    flex-wrap: wrap;
  }

  .body-source-mark-list-item {
    width: 50%;
    height: 28px;
  }

  .body-mark-right-related-title p {
    line-height: 28px;
  }

  .body-source-mark-list-item-tit {
    width: 80px;
  }

  .body-source-mark-list-item-desc {
    margin-left: 50px;
  }

  .dplayer-played {
    background: #264480 !important;;
  }

  .body-source-list-type {
    margin-top: 8px;
  }

  .share-tip {
    width: 326px;
    height: 170px;
    border: 1px solid rgba(26, 59, 128, 0.2);
    top: 50px;
    right: 0;
  }

  .share-code {
    width: 155px;
    border-right: 1px solid #D1D8E6;
  }

  .share-code-img {
    width: 100px;
    height: 100px;
    margin-top: 6px;
    background-color: blueviolet;
  }

  .body-source-wrap-zip {
    width: 100%;
    height: 100%;
    background-image: url('../../../assets/icon-resource-zip-bg.jpg');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }

  .date:last-child p:last-child {
    display: none;
  }

  .category:last-child p:last-child {
    display: none;
  }

  .personAffecteds:last-child p:last-child {
    display: none;
  }

  .body-mark-left-item-value-wrap:last-child .line {
    display: none;
  }

  .body-source-wrap-video-info-btn {
    top: 10px;
    right: 10px;
    z-index: 998;
  }

  .video-normal {
   width: 960px;
   height: 600px;
  }

  .flex-wrap {
    flex-wrap: wrap;
    padding: 20px 0;
  }

  .error-view {
    height: 720px;
  }

  .personaffecteds:last-child p:last-child {
    display: none;
  }

  .full-screen {
    position: fixed;
    width: 100%;
    height: 100vh;
    z-index: 99999;
    top: 0;
    left: 0;
    margin: 0;
  }

  .video-full-screen {
    width: 100%;
    height: 100%;
  }

</style>
